export type Skill = {
  name: string;
  level: number; // percentage 0-100
  category: 'Frontend' | 'Backend' | 'Mobile' | 'Tools';
};

export type Project = {
  id: string;
  title: string;
  description: string;
  tech: string[];
  role: string;
  highlight: string;
  imageAlt: string;
  imageUrl?: string;
  liveUrl?: string;
  repoUrl?: string;
};

export const heroContent = {
  name: 'Marco Biosa',
  title: 'Certified Software Technician & Full Stack Developer',
  subtitle: 'React, Flutter, Next.js | From laminate to code',
  tagline:
    "I'm a certified Software Technician and Full Stack Developer with a hands-on background in manual work. This experience gives me strong practical skills, attention to detail, and high adaptability when building digital solutions.",
  ctaPrimary: 'View projects',
  ctaSecondary: 'Download CV',
};

export const aboutContent = {
  bio: `I am a self-taught junior full‑stack developer with a background as a flooring installer. 
I bring the same attention to detail and strong work ethic from construction into my code. 
Outside of coding I enjoy the gym, fishing, and constantly learning new technologies.`,
  location: 'Sardinia, Italy',
  availability: 'Open to junior and internship opportunities – remote or hybrid.',
  interests: ['Clean UI', 'Mobile apps', 'Open source', 'AI & Innovation', 'Cloud Computing', 'DevOps', 'Web Development'],
};

export const skills: Skill[] = [
  { name: 'HTML & CSS', level: 80, category: 'Frontend' },
  { name: 'JavaScript (ES6+)', level: 75, category: 'Frontend' },
  { name: 'TypeScript', level: 70, category: 'Frontend' },
  { name: 'React', level: 75, category: 'Frontend' },
  { name: 'Next.js', level: 80, category: 'Frontend' },
  { name: 'Flutter', level: 70, category: 'Mobile' },
  { name: 'Python', level: 70, category: 'Backend' },
  { name: 'Firebase', level: 70, category: 'Backend' },
  { name: 'SQL', level: 70, category: 'Backend' },
  { name: 'Laravel', level: 70, category: 'Backend' },
  { name: 'Django', level: 80, category: 'Backend' },
  { name: 'Linux & CLI', level: 70, category: 'Tools' },
];

export const projects: Project[] = [
  {
    id: 'react-todo',
    title: 'AI Note Studio',
    description:
      'A full-stack note-taking application with an integrated AI chatbot that uses Retrieval-Augmented Generation (RAG) to intelligently query user notes through natural language.',
    tech: ['Next.js 15', 'React', 'TypeScript', 'Convex', 'Vercel AI SDK v5', 'OpenAI API', 'Vector Search'],
    role: 'Full-stack development, AI integration',
    highlight:
      'Key Features: User authentication and secure session management, rich-text editor for note creation, AI-powered chatbot with semantic search across personal notes, vector embeddings for contextual content retrieval, and real-time streaming responses.',
    imageAlt: 'Screenshot of AI Note Studio application with note editor and AI chatbot interface.',
    imageUrl: '/media/projects/CardAiNoteStudio.png',
    liveUrl: 'https://ai-note-studio-rosy.vercel.app',
    repoUrl: 'https://github.com/Markitos998/ai-note-studio',
  },
  {
    id: 'flutter-firebase',
    title: 'SimplySocial',
    description:
      'A minimalist static social media frontend showcasing modern design principles with Apple-inspired aesthetics and Instagram-like features. Built with zero framework overhead for maximum performance and instant deployment.',
    tech: ['HTML5', 'CSS3 (Variables, Grid, Flexbox)', 'Vanilla JavaScript ES6+', 'Bootstrap 3 Grid', 'Vercel Edge Network'],
    role: 'Frontend development, UI/UX design',
    highlight:
      'Key Features: Complete design system with Inter typography, 4px spacing, and reusable components • Native dark/light mode toggle with localStorage persistence and 180ms smooth transitions • Responsive mobile-first layout with semantic HTML5 and full accessibility support • Interactive navigation bar, hero section with gradient effects, and modular card system • Vanilla JavaScript ES6+ with zero framework overhead for optimal performance • Integrated Vercel Analytics and Speed Insights for real-time monitoring',
    imageAlt: 'MB Solutions logo - full-stack dev portfolio.',
    liveUrl: 'https://simple-social-example.mbsolutions.dev/',
    repoUrl: 'https://github.com/marcobiosa/flutter-fitness-tracker',
  },
  {
    id: 'next-portfolio',
    title: 'Next.js Developer Portfolio',
    description:
      'A fast, SEO-friendly multi-page portfolio built with Next.js and Tailwind CSS.',
    tech: ['Next.js', 'TypeScript', 'Tailwind CSS'],
    role: 'Full-stack implementation',
    highlight:
      'Practiced file-based routing, SEO meta tags, and responsive layouts.',
    imageAlt: 'Screenshot of a modern Next.js portfolio homepage.',
    liveUrl: 'https://vercel.com/placeholder-next-portfolio',
    repoUrl: 'https://github.com/marcobiosa/next-portfolio',
  },
  {
    id: 'sql-dashboard',
    title: 'SQL Analytics Dashboard',
    description:
      'Simple dashboard UI example consuming data from a SQL-backed API.',
    tech: ['React', 'TypeScript', 'SQL'],
    role: 'Frontend and data visualization',
    highlight:
      'Focused on data tables, charts, and clean information hierarchy.',
    imageAlt: 'Dashboard UI with charts and tables.',
    liveUrl: 'https://vercel.com/placeholder-sql-dashboard',
    repoUrl: 'https://github.com/marcobiosa/sql-analytics-dashboard',
  },
];

export const contactContent = {
  email: 'm.biosa@outlook.it',
  socials: {
    github: 'https://github.com/Markitos998',
    linkedin: 'https://www.linkedin.com/in/marco-biosa-921495195/',
    instagram: 'https://www.instagram.com/markquitos/',
  },
};



